import { getParam } from '@amusnet/react-ui'
import { useConfigurationStore } from '@stores'

const History = () => {
    const gameHistoryApi = useConfigurationStore((state) => state.gameHistoryApi)
    const gameNumber = useConfigurationStore((state) => state.gin)
    const token = useConfigurationStore((state) => state.token)
    const language = useConfigurationStore((state) => state.language)
    const currency = useConfigurationStore((state) => state.currency)
    const gameHistoryUrl = useConfigurationStore((state) => state.gameHistoryUrl)
    const hasBuyBonus = useConfigurationStore((state) => state.hasBuyBonus)
    const promoModes = useConfigurationStore((state) => state.promoModes)
    const hasAccumulatedMaxCap = useConfigurationStore((state) => state.hasAccumulatedMaxCap)

    const params = {
        api: gameHistoryApi,
        gin: gameNumber,
        token,
        lang: language,
        currency,
        cloudflareEnabled: window.amusnetLibrary.PIXILoader.shouldUseCloudflareImageOptimization,
        design: 'slot',
        baseUrl: getParam('baseUrl')?.trim(),
        skipWinAnimationsCoef: getParam('skipWinAnimationsCoef'),
        promoModes,
        hasBuyBonus,
        hasAccumulatedMaxCap,
    }

    const iframeSrc = `${gameHistoryUrl}/?${new URLSearchParams(params as unknown as Record<string, string>)}`

    return (
        <div className="relative w-full h-full">
            <div
                id="gameHistoryIframe"
                className="absolute w-full h-full touch-none transform-gpu translate-x-0 translate-y-0 overflow-hidden"
            >
                <iframe src={iframeSrc} className="block touch-none w-full h-full border-none ml-2"></iframe>
            </div>
        </div>
    )
}

export default History
